
<template>
  <div :class="[formGroupClass,'form-group']">
    <label class="control-label" v-if="alias">{{ alias }}:</label>
    <input
      :ref="name"
      type="date"
      :class="['form-control', 'form-control-sm', { 'is-invalid' : getError }]"
      :value="value"
      :name="name"
      :disabled="disabled"
      @input="onInput"
      @blur="onBlur"
      @change="onChange($event)"
    />
    <div class="invalid-feedback invalid-feedback-overwrite" v-if="getError">{{ getError }}</div>
  </div>
</template>

<script>
export default {
  //:class="{ 'is-invalid' : getError }"
  props: {
    value: {},

    formGroupClass: {},

    name: {},
    alias: {},

    disabled: {
      default: false
    },

    form: {
      default: null
    },
    error: {}
  },

  computed: {
    getError() {
      if (this.form !== null) {
        return this.form.getErrors(this.name);
      }
      return false;
    }
  },

  methods: {
    onInput(event) {
      this.$emit("input", event.target.value);
    },

    onBlur(event) {
      this.$emit("blur");
      this.validate();
    },

    onChange(event){
            this.$emit('change', event.target.value)
        },

    validate() {
      if (this.form != undefined) {
        this.form.validate(this.name);
      }
    },

    setFocus() {
      this.$refs[this.name].focus();
    }
  }
};
</script>

<style>
.invalid-feedback-overwrite {
  font-size: 12px;
}
input[type="date"]::-webkit-inner-spin-button,    
input[type="date"]::-webkit-clear-button { display: none; }
</style>

